var map = {
	"./1.jpg": 3852,
	"./10.jpg": 4653,
	"./11.jpg": 8445,
	"./12.jpg": 9907,
	"./13.jpg": 9523,
	"./14.jpg": 1963,
	"./15.jpg": 4391,
	"./2.jpg": 9072,
	"./3.jpg": 7510,
	"./4.jpg": 3634,
	"./5.jpg": 5068,
	"./6.jpg": 2610,
	"./7.jpg": 8760,
	"./8.jpg": 7019,
	"./9.jpg": 729,
	"./无土栽培.jpg": 8573,
	"./架式草莓.jpg": 5107,
	"./科学补光.jpg": 6292,
	"./科普教育.jpg": 7085,
	"./观赏葫芦.jpg": 8950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1950;